import { createApp } from "vue";
import "./style.css";
import ChangelogPage from "./ChangelogPage.vue";

createApp(ChangelogPage).mount("#app");
